var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 331.94 58.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.39,58.69A8.06,8.06,0,0,1,.32,54a15.67,15.67,0,0,1,1.92-4.24,35.78,35.78,0,0,1,5.93-6.79A86.9,86.9,0,0,1,22.56,32.65a156.75,156.75,0,0,1,15.71-7.88c5.39-2.29,10.89-4.31,16.46-6.11S65.87,15,71.63,13.52a64,64,0,0,1,17.91-2.16,54.56,54.56,0,0,1,18.35,3.43c5.9,2.27,11.51,6.15,14.71,11.47l-.89,1.08a50.49,50.49,0,0,0-16-2.84,111.49,111.49,0,0,0-15.65.88c-5.26.62-10.58,1.25-16,1.72a143.57,143.57,0,0,0-16.46,2.33q-8.16,1.66-16.17,4a152.68,152.68,0,0,0-15.77,5.41,86.42,86.42,0,0,0-14.78,7.47A32.58,32.58,0,0,0,4.6,51.48c-1.76,1.93-3.24,4.3-2.85,6.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.29,42c.25-2.55-1.34-4.84-3.19-6.67a32.43,32.43,0,0,0-6.49-4.79,85.58,85.58,0,0,0-15.08-6.68,151.14,151.14,0,0,0-16-4.58c-5.38-1.3-10.83-2.37-16.3-3.2a114.73,114.73,0,0,0-16.38-1.28c-5.42-.08-10.73-.22-16-.45a158.51,158.51,0,0,0-15.87.11c-2.65.18-5.31.45-8,.89a50.74,50.74,0,0,0-8.15,2L208,16.25a20.36,20.36,0,0,1,2.87-3.68,28.08,28.08,0,0,1,3.53-3.1,40.94,40.94,0,0,1,8.12-4.64A60.12,60.12,0,0,1,240.31.32a61.79,61.79,0,0,1,18,.81c5.88,1.07,11.6,2.62,17.26,4.08s11.21,3.24,16.69,5.25a155.32,155.32,0,0,1,16,7A86.24,86.24,0,0,1,323.12,27a35.47,35.47,0,0,1,6.25,6.46,15.51,15.51,0,0,1,2.12,4.13,8,8,0,0,1,.17,4.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset49);
export default __webpack_public_path__ + "static/media/Asset 49.7e645b6c.svg";
export { ForwardRef as ReactComponent };